module.exports = __webpack_public_path__ + "img/logo_small.a4023726.jpg";